"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerkleDistributorFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MerkleDistributorFactory = /** @class */ (function (_super) {
    __extends(MerkleDistributorFactory, _super);
    function MerkleDistributorFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MerkleDistributorFactory.prototype.deploy = function (token_, merkleRoot_, overrides) {
        return _super.prototype.deploy.call(this, token_, merkleRoot_, overrides || {});
    };
    MerkleDistributorFactory.prototype.getDeployTransaction = function (token_, merkleRoot_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, token_, merkleRoot_, overrides || {});
    };
    MerkleDistributorFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MerkleDistributorFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MerkleDistributorFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MerkleDistributorFactory;
}(contracts_1.ContractFactory));
exports.MerkleDistributorFactory = MerkleDistributorFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "token_",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "merkleRoot_",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "active",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "switchActive",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
